<template>
  <BaseModal :config="MemoModalLabel" @ResetFields="resetFields" @SaveChanges="saveChanges">
    <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
      <form ref="refMemoForm" id="MemoForm" action>
          <div id="pageErrors"
				class="alert alert-danger" v-if="pageErrors.length>0">
				<p>
				<b>Please correct the following error(s):</b>
				    <ul>
						<li v-for="error in pageErrors"
							:key="error">{{ error }}</li>
						</ul>
					</p>
			</div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label class="required-label">Type</label>
            <div id="kendo-select">
              <kendo-dropdownlist
                v-model="MemoInfo.MemoType"
                :disabled="bDisableFields"
                :data-source="dropdowns.MemoType.dataSource"
                :data-text-field="'Option'"
                :option-label="'Select Memo Type'"
                :data-value-field="'Option'"
                name="Memo Type"
                @change="onMemoTypeChange"
              ></kendo-dropdownlist>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="required-label">Tax Period</label>
            <div id="kendo-select">
              <kendo-dropdownlist
                v-model="MemoInfo.TaxPeriod"
                :disabled="bDisableFields"
                :data-source="dropdowns.TaxPeriod.dataSource"
                :data-text-field="'Option'"
                :option-label="'Select Tax Period'"
                :data-value-field="'Option'"
                name="Unit Class"
              ></kendo-dropdownlist>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label :class="{'required-label': !bDisableProgram}">Program</label>
            <div class="input-group mb-3 pl-0">
              <kendo-autocomplete
                id="SearchMemoProgram"
                class="form-control"
                v-model="MemoInfo.ProgramTitle"
                :data-source="programAutoCompleteSource"
                :data-text-field="'Title'"
                :filter="'contains'"
                :placeholder="'Search for Program'"
                :disabled="bDisableProgram"
                @select="onProgramAutoCompleteSelect"
                @open="onProgramOpen"
                @close="onProgramClose"
              ></kendo-autocomplete>
              <div class="input-group-append">
                <span class="input-group-text">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label :class="{'required-label': !bDisableInvestment}">Investment</label>
            <div class="input-group mb-3 pl-0">
              <kendo-autocomplete
                id="SearchMemoInvestment"
                class="form-control"
                v-model="MemoInfo.InvestmentTitle"
                :data-source="investmentAutoCompleteSource"
                :data-text-field="'Title'"
                :filter="'contains'"
                :placeholder="'Search for Investment'"
                :disabled="bDisableInvestment"
                @select="onInvestmentAutoCompleteSelect"
                @open="onInvestmentOpen"
                @close="onInvestmentClose"
              ></kendo-autocomplete>
              <div class="input-group-append">
                <span class="input-group-text">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label :class="{'required-label': !bDisableLocation}">Location</label>
            <div id="kendo-select">
              <kendo-dropdownlist
                v-model="MemoInfo.Location"
                :disabled="bDisableLocation"
                :data-source="dropdowns.Location.dataSource"
                :data-text-field="'Option'"
                :option-label="'Select Location'"
                :data-value-field="'Option'"
                name="Location"
              ></kendo-dropdownlist>
            </div>
          </div>
        </div>

        <div class="form-row">
        <div class="form-group col-md-12">
        <label class="required-label">Memo Text</label>
          <textarea
            class="form-control"
            rows="6"
            cols="50"
            id="MemoText"
            placeholder="Text"
            v-model="MemoInfo.MemoText"
          ></textarea>
        </div>
        </div>
      </form>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/base/BaseModal.vue";
import funcUtil from "@/services/funcUtil.js";
import BaseModelMemo from "@/models/BaseModelMemo.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MemoForm",
  components: {
    BaseModal
  },
  mixins: [funcUtil],
  computed: {
    ...mapGetters("getModule", ["withFilter","getLocalInputControls"]),
  },
  props: {
    MemoInfo: {},
    MemoModalLabel: {}
  },
  data: function() {
    return {
      GridConfig: BaseModelMemo,
      BaseModelProgram: BaseModelProgram,
      BaseModelInputControl:BaseModelInputControl,
      dropdowns: {
        MemoType: { model: "", dataSource: [] },
        TaxPeriod: { model: "", dataSource: [] },
        Location: { model: "", dataSource: [] }
      },
      programAutoCompleteSource:[],
      investmentAutoCompleteSource:[],
      bProgramValid: true,
      bInvestmentValid: true,
      pageErrors:[],
      bDisableFields:false,
      bDisableProgram:false,
      bDisableInvestment:false,
      bDisableLocation: true
    };
  },
  methods: {
    ...mapActions("postModule", ["UpdateItems", "CreateItems"]),
    onProgramAutoCompleteSelect(e) {
      this.bProgramValid = true;
      this.MemoInfo.ProgramId = e.dataItem.Id;
      this.MemoInfo.ProgramTitle = e.dataItem.Title;
    },
    onProgramOpen() {
      this.bProgramValid = false;
    },
    onProgramClose() {
      if (!this.bProgramValid) {
        this.MemoInfo.ProgramId = null;
        this.MemoInfo.ProgramTitle = null;
      }
    },
    onInvestmentAutoCompleteSelect(e) {
      this.bInvestmentValid = true;
      this.MemoInfo.InvestmentId = e.dataItem.Id;
      this.MemoInfo.InvestmentTitle = e.dataItem.Title;
    },
    onInvestmentOpen() {
      this.bInvestmentValid = false;
    },
    onInvestmentClose() {
      if (!this.bInvestmentValid) {
        this.MemoInfo.InvestmentId = null;
        this.MemoInfo.InvestmentTitle = null;
      }
    },
    resetFields(e) {
        this.pageErrors = [];
    },
    getAutoCompleteData() {
      this.programAutoCompleteSource = this.withFilter(BaseModelProgram.list);
      this.investmentAutoCompleteSource = this.withFilter(BaseModelInvestment.list);
    },
    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(self.BaseModelInputControl.list);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
          self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
        });
        //this.TaxPeriodOptions=this.dropdowns.TaxPeriod.dataSource;
        if (this.dropdowns.TaxPeriod.dataSource.length>0) {
        this.dropdowns.TaxPeriod.dataSource=_.orderBy(this.dropdowns.TaxPeriod.dataSource.filter(element => {
          return (element.Option.trim())
        }),["Option"],["desc"])
        }
      },
    saveChanges(e) {
      let self = this;
      if(self.Validate()){

        //Validate For Duplicate Data: BAsed on Criteria
        if (!(self.MemoInfo.MemoType =="Program" || self.MemoInfo.MemoType =="Investment") && this.MemoModalLabel.modalAddorEdit == "add") {
            let MemoListData=self.withFilter(BaseModelMemo.list);
            let index = MemoListData.findIndex( (m)=>{
                return m.MemoType.toLowerCase()==self.MemoInfo.MemoType.toLowerCase() && 
                m.TaxPeriod.toLowerCase() == self.MemoInfo.TaxPeriod.toLowerCase()
            })
            if(index>=0){
                self.pageErrors.push(`Memo Text for Tax Period ${self.MemoInfo.TaxPeriod} and Type 
                ${self.MemoInfo.MemoType} already exists`)
                return
            }
        }

        if (this.MemoModalLabel.modalAddorEdit == "add") {
            let addFormValues = self.MemoInfo;
            let createItem = {
            list: self.GridConfig,
            payload: addFormValues
            };
            //let loader = self.$loading.show();
            self._APICrudPopup("APICrudpopup");
            self.CreateItems(createItem).then(res => {
                $("#MemoGrid").data().kendoGrid.dataSource.read();
                self._AlertPopup("Data Saved Successfully!", "success");
            }).catch(error=>{
                self._AlertPopup("Some Error Occurred!","info");
            }).finally(() => {
                //loader.hide();
            });
        } else {
            let editFormValues = self.MemoInfo;
            let updateItem = {
            list: self.GridConfig,
            payload: editFormValues
            };
            //let loader = self.$loading.show();
            self._APICrudPopup("APICrudpopup");
            self.UpdateItems(updateItem).then(res => {
                $("#MemoGrid").data().kendoGrid.dataSource.read();
                self._AlertPopup("Data Updated Successfully!", "success");
            }).catch(error=>{
                self._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
                //loader.hide();
            })
        }
            $("#BaseModal").modal("toggle");
            self.resetFields();
        }
    },
    Validate() {
      const self = this;
      self.pageErrors = [];
      let form = self.MemoInfo;
      console.log(form);
      //Form Validations
      if (!(form.ProgramTitle && form.ProgramId) && !this.bDisableProgram) {
        self.pageErrors.push("Program is required");
      }
      //Investment
      if (!(form.InvestmentTitle && form.InvestmentId) && !this.bDisableInvestment) {
        self.pageErrors.push("Investment is required");
      }
      //Memo Type
      if (form.MemoType == "") {
        self.pageErrors.push("Memo Type is required");
      }
      //Tax Period
      if (form.TaxPeriod == "") {
        self.pageErrors.push("Tax Period is required");
      }
      //Memo Text
      if (form.MemoText == "") {
        self.pageErrors.push("Memo Text is required");
      }
      //Location Validations
      if (!(form.Location) && !this.bDisableLocation) {
        self.pageErrors.push("Location is required");
      }
      if (self._validateSpecialCharacter(form.MemoText,"multiline")) {
        self.pageErrors.push(`Memo Text cannot have ${this.MultiLineSpecialChars}  Characters`);
      }
      return self.pageErrors.length > 0 ? false : true;
    },
    onMemoTypeChange(e){
        let newMemoType = e.sender.value();
        this.MemoInfo.MemoType = newMemoType;
        this.DisableField(this.MemoInfo);
    },
    DisableField(formValue){
     //alert(this.MemoInfo.MemoType)
        if (formValue.MemoType!="Program") {
            this.bDisableProgram=true
            formValue.ProgramId=null
            formValue.ProgramTitle=null
        }else{
            this.bDisableProgram=false
        }   
        if (formValue.MemoType!="Investment") {
            this.bDisableInvestment=true
            formValue.InvestmentId=null
            formValue.InvestmentTitle=null
        }else{
            this.bDisableInvestment=false
        }
        if(formValue.MemoType=="Investment" || formValue.MemoType=="Program"){
          this.bDisableLocation = false;
        }
        else {
          this.bDisableLocation = true;
        }
    }
  },
  mounted(){
    this.getInputControls();
    this.getAutoCompleteData();
    this.resetFields();
    //For Displaying List on Focus
    this.ShowAutoCompleteListOnFocus("SearchMemoProgram");
    this.ShowAutoCompleteListOnFocus("SearchMemoInvestment");
  }
};
</script>

<style>
</style>
